var map = {
	"./_storyteller.png": 1923,
	"./acrobat.png": 8211,
	"./alchemist.png": 7093,
	"./alhadikhia.png": 9589,
	"./amnesiac.png": 7656,
	"./angel.png": 9778,
	"./apprentice.png": 6400,
	"./artist.png": 4944,
	"./assassin.png": 9586,
	"./atheist.png": 7323,
	"./balloonist.png": 5278,
	"./barber.png": 5839,
	"./barista.png": 9863,
	"./baron.png": 6821,
	"./beggar.png": 8521,
	"./bishop.png": 922,
	"./bonecollector.png": 7390,
	"./boomdandy.png": 4422,
	"./bountyhunter.png": 4018,
	"./buddhist.png": 6422,
	"./bureaucrat.png": 3211,
	"./butcher.png": 8664,
	"./butler.png": 7883,
	"./cannibal.png": 6443,
	"./cerenovus.png": 1541,
	"./chambermaid.png": 7142,
	"./chef.png": 5685,
	"./choirboy.png": 6492,
	"./clockmaker.png": 8427,
	"./courtier.png": 4614,
	"./cultleader.png": 4546,
	"./custom.png": 788,
	"./damsel.png": 9867,
	"./deusexfiasco.png": 7434,
	"./deviant.png": 2292,
	"./devilsadvocate.png": 2203,
	"./djinn.png": 7566,
	"./doomsayer.png": 544,
	"./dreamer.png": 1149,
	"./drunk.png": 3991,
	"./duchess.png": 6082,
	"./empath.png": 8210,
	"./engineer.png": 6018,
	"./evil.png": 9779,
	"./eviltwin.png": 4981,
	"./exorcist.png": 664,
	"./fabled.png": 4159,
	"./fanggu.png": 2451,
	"./farmer.png": 7020,
	"./fearmonger.png": 8655,
	"./fibbin.png": 2595,
	"./fiddler.png": 6489,
	"./fisherman.png": 6088,
	"./flowergirl.png": 6810,
	"./fool.png": 737,
	"./fortuneteller.png": 1254,
	"./gambler.png": 359,
	"./gangster.png": 3740,
	"./general.png": 1921,
	"./goblin.png": 6188,
	"./godfather.png": 3481,
	"./golem.png": 2417,
	"./good.png": 2286,
	"./goon.png": 3044,
	"./gossip.png": 5442,
	"./grandmother.png": 7398,
	"./gunslinger.png": 9289,
	"./harlot.png": 9871,
	"./hellslibrarian.png": 5385,
	"./heretic.png": 519,
	"./huntsman.png": 3851,
	"./imp.png": 8523,
	"./innkeeper.png": 2926,
	"./investigator.png": 3118,
	"./judge.png": 5816,
	"./juggler.png": 1415,
	"./king.png": 2072,
	"./klutz.png": 3465,
	"./legion.png": 2207,
	"./leviathan.png": 3323,
	"./librarian.png": 4461,
	"./lilmonsta.png": 6566,
	"./lleech.png": 6646,
	"./lunatic.png": 5323,
	"./lycanthrope.png": 5344,
	"./magician.png": 9802,
	"./marionette.png": 7985,
	"./mastermind.png": 7991,
	"./mathematician.png": 3184,
	"./matron.png": 8594,
	"./mayor.png": 2469,
	"./mephit.png": 888,
	"./mezepheles.png": 8043,
	"./minion.png": 6823,
	"./minstrel.png": 6999,
	"./monk.png": 8724,
	"./moonchild.png": 2530,
	"./mutant.png": 2672,
	"./nightwatchman.png": 1156,
	"./noble.png": 4309,
	"./nodashii.png": 7630,
	"./oracle.png": 9407,
	"./outsider.png": 8608,
	"./pacifist.png": 2438,
	"./philosopher.png": 7144,
	"./pithag.png": 1480,
	"./pixie.png": 4048,
	"./plus.png": 8349,
	"./po.png": 3390,
	"./poisoner.png": 7640,
	"./politician.png": 4759,
	"./poppygrower.png": 3953,
	"./preacher.png": 9877,
	"./professor.png": 2014,
	"./psychopath.png": 7668,
	"./pukka.png": 5945,
	"./puzzlemaster.png": 179,
	"./ravenkeeper.png": 3249,
	"./recluse.png": 2366,
	"./revolutionary.png": 7272,
	"./riot.png": 5575,
	"./sage.png": 5001,
	"./sailor.png": 7705,
	"./saint.png": 234,
	"./savant.png": 1588,
	"./scapegoat.png": 282,
	"./scarletwoman.png": 5333,
	"./seamstress.png": 8119,
	"./sentinel.png": 8845,
	"./shabaloth.png": 1935,
	"./slayer.png": 7531,
	"./snakecharmer.png": 2217,
	"./snitch.png": 1604,
	"./soldier.png": 3531,
	"./spiritofivory.png": 5038,
	"./spy.png": 1247,
	"./stormcatcher.png": 4444,
	"./sweetheart.png": 1829,
	"./tealady.png": 2179,
	"./thief.png": 1577,
	"./tinker.png": 9008,
	"./towncrier.png": 7548,
	"./toymaker.png": 8813,
	"./undertaker.png": 5730,
	"./vigormortis.png": 1594,
	"./virgin.png": 802,
	"./vortox.png": 9943,
	"./voudon.png": 8292,
	"./washerwoman.png": 5475,
	"./widow.png": 6879,
	"./witch.png": 4508,
	"./x.png": 4693,
	"./zombuul.png": 4047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5994;